module.exports = __webpack_public_path__ + "img/002.8f0d4119.svg";